import React, { useState, useRef } from 'react';
import TextField from '@PROJECT_ROOT/assets/responsive-frontend/js/formFields/textField';
import CheckBoxField from '@PROJECT_ROOT/assets/responsive-frontend/js/formFields/checkBoxField';
import HoneypotField from '@PROJECT_ROOT/assets/responsive-frontend/js/formFields/honeypotField';
import formInputValidator from '@PROJECT_ROOT/assets/responsive-frontend/js/services/formInputValidator';
import generateState from '@PROJECT_ROOT/assets/responsive-frontend/js/services/generateStateService';
import { reportError } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/reportService';
import { toast } from 'react-toastify';
import { IS_FRAME_SERVICE } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/frameService';
import { dispatchTrackingEvent, dispatchUserIdentified, HOMEPAGE_NEWSLETTER_SUBSCRIBE_SUBMIT } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/tracking';
import { subscribeToNewsletter } from '@PROJECT_ROOT/assets/responsive-frontend/js/apiServices/NewsletterService';

export default function NewsletterForm({ data }) {
    const formElementRef = useRef(null);
    const [, setErrorValidationMsg] = useState(null);
    const [isSubmit, setIsSubmit] = useState(false);
    const [isPostLoading, setIsPostLoading] = useState(false);
    const [formData, setFormData] = useState(generateState.formStateGenerator(data.formElements));

    const handleInputChange = (e) => {
        e.persist();
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleFeedbackErrors = (errorData) => {
        if (formElementRef.current) {
            formInputValidator.displayValidationErrorMessages(errorData.validationErrorMessages, formElementRef.current);
        }
    };

    const postData = () => {
        setIsPostLoading(true);
        subscribeToNewsletter(formData)
            .then((res) => {
                formInputValidator.removeValidationMessages(formElementRef.current);
                setErrorValidationMsg(null);
                if (res.data.validationErrorMessages) {
                    setErrorValidationMsg(res.data);
                    handleFeedbackErrors(res.data);
                }
                if (res.data.status === 'failure') {
                    toast.error(res.data.message?.title);
                } else if (res.data.status === 'success') {
                    setFormData(generateState.formStateGenerator(data.formElements));
                    setIsSubmit(false);
                    toast.success(res.data.message?.title);
                    if (!IS_FRAME_SERVICE) {
                        dispatchTrackingEvent(HOMEPAGE_NEWSLETTER_SUBSCRIBE_SUBMIT);
                        dispatchUserIdentified(formData.email);
                    }
                }
            })
            .catch((err) => {
                reportError(err);
            })
            .finally(() => {
                setIsPostLoading(false);
            });
    };

    const handleCheckBox = (e) => {
        e.persist();
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.checked,
        }));
    };

    const handleSubmitForm = (e) => {
        e.preventDefault();
        if (formData.confirmEmail && formData.confirmEmail !== '') {
            return;
        }
        setIsSubmit(true);
        if (formInputValidator.isRequiredFieldsFilled(formData, data.formElements)) {
            postData();
        }
    };

    return (
        data && (
            <div className="newsletterSection">
                <div className="newsletterSectionInner">
                    <div className="newsletterSectionInner--header">
                        <h4 className="newsletter-section__title">
                            {data.title}
                        </h4>
                        <p className="newsletter-section__description">
                            {data.text}
                        </p>
                    </div>
                    <form
                        className="form__wrapper"
                        ref={formElementRef}
                        onSubmit={handleSubmitForm}
                    >
                        {data.formElements.map((element, index) => {
                            switch (element.type) {
                                case 'emailField':
                                    return (
                                        <div className="form__article  form__article-input" key={index}>
                                            <TextField
                                                fieldData={element}
                                                currentStateValue={formData[element.name]}
                                                onChangeHandler={handleInputChange}
                                                controlStateData={{ isSubmit }}
                                                inputType="email"
                                            />
                                        </div>
                                    );
                                case 'checkBox':
                                    return (
                                        <div className="form__article form__article-checkbox" key={index}>
                                            <CheckBoxField
                                                fieldData={element}
                                                currentStateValue={formData[element.name]}
                                                onChangeHandler={handleCheckBox}
                                                controlStateData={{ isSubmit }}
                                                shouldLabelIncludeAsteriskIfRequired={false}
                                            />
                                        </div>
                                    );
                                case 'honeypotField':
                                    return (
                                        <HoneypotField
                                            key={index}
                                            fieldData={element}
                                            currentStateValue={formData[element.name]}
                                            onChangeHandler={handleInputChange}
                                            controlStateData={{ isSubmit }}
                                        />
                                    );
                                default:
                                    return null;
                            }
                        })}
                        <button
                            type="submit"
                            id="newsletterFooterYes"
                            className="adr-btn-primary-md newsletter-section__submit-button"
                            disabled={isPostLoading}
                            onClick={() => {
                                if (!IS_FRAME_SERVICE) dispatchTrackingEvent(HOMEPAGE_NEWSLETTER_SUBSCRIBE_SUBMIT);
                            }}
                        >
                            {data.submitAction.title}
                        </button>
                    </form>
                </div>
            </div>
        )
    );
}
